import { Method } from '@inertiajs/inertia'
import { Head, Link } from '@inertiajs/inertia-react'
import { EditMenuContextProvider } from 'app/fragments/TaskCard'
import React from 'react'
import route from 'ziggy-js'
import Footer from './Footer'
import Header from './Header'
import Modals from './Modals'
import SideBar from './SideBar'

interface Props {
    className?: string
    children
    heading?: string
    withoutPadding?: boolean
}

function Layout(props: Props) {
    const { className, children, heading, withoutPadding } = props

    return (
        <EditMenuContextProvider>
            <Head title={"Timea - Time is money"}>
                <meta head-key="description" name="description" content="Time is money friend." />
            </Head>
            <div className="min-h-screen bg-black flex w-full relative">

                <SideBar />
                <main className={`w-full z-0 relative flex flex-col text-white    ${className} max-h-screen overflow-y-auto overflow-x-hidden`}>
                    <Header heading={heading} />
                    <div className={`flex-grow pb-40px ${!withoutPadding && 'pl-200px pr-130px'} mob:px-20px`}>
                        {children}
                    </div>
                    <Footer />
                </main>

            </div>

            <Modals />
        </EditMenuContextProvider>
    )
}

export default Layout
